const issueKeyRegex = /^([A-Z][A-Z0-9_]+-)?\d+$/i;
const japaneseAndChineseRegex =
	/[\p{Script_Extensions=Hiragana}\p{Script_Extensions=Katakana}\p{Script_Extensions=Han}]/u;
const searchTextRegex = /\(summary ~ '(?<searchText>.+?)' OR description ~ '.+?'/;

const sanitize = (value: string) =>
	value.replace(/\\/g, '\\\\').replace(/'/g, "\\'").replace(/\t/g, ' ');

const getSearchTextJQL = (text: string | undefined): string | undefined => {
	if (text == null) {
		return undefined;
	}

	if (text.trim() === '') {
		return '';
	}

	let search = sanitize(text);

	if (issueKeyRegex.test(text)) {
		return `(summary ~ '${search}*' OR description ~ '${search}*' OR key ~ '${search}')`;
	}

	// if the text does not contain Chinese or Japanese characters (which are not tokenized),
	// and does not end with a space character
	// make it a wildcard search
	if (!japaneseAndChineseRegex.test(text) && !text.endsWith(' ')) {
		search = `${search}*`;
	}

	return `(summary ~ '${search}' OR description ~ '${search}')`;
};

export const combineFilterJqlWithSearchText = (
	filterJql: string | undefined,
	searchText: string | undefined,
): string | undefined => {
	const textSearchJql = getSearchTextJQL(searchText);
	if (filterJql && textSearchJql) {
		return `${filterJql} AND ${textSearchJql}`;
	}
	if (filterJql && textSearchJql == null) {
		return filterJql;
	}
	if (textSearchJql && filterJql == null) {
		return textSearchJql;
	}
	return filterJql || textSearchJql;
};

/**
 * Returns an array with filter JQL as first element and extracted search text as second element.
 */
export const extractSearchTextFromJql = (jql: string): [string, string] => {
	const match = jql.match(searchTextRegex);
	if (match) {
		let searchText = match.groups?.searchText || '';
		// remove any trailing wildcard from the extracted search text
		searchText = searchText.replace(/\*$/, '');

		// the filter JQL is everything before the matched search text JQL
		// so we split the original JQL at the start index of the match
		let filterJql = jql.slice(0, match.index).trim();
		// remove any trailing AND from the filter JQL
		filterJql = filterJql.replace(/AND\s*$/i, '').trim();

		return [filterJql, searchText];
	}
	return [jql, ''];
};
